import decodeJwt from 'jwt-decode'

const isLocal = process.env.REACT_APP_APP_ENV === 'local'

export default {
  // called when the user attempts to log in
  login: token => {
    localStorage.setItem('token', token)
    return Promise.resolve()
  },
  // called when the user clicks on the logout button
  logout: () => {
    localStorage.removeItem('token')
    // In local the login page signs you straight back in as the default
    // account, so ask it for the account list instead.
    return Promise.resolve(isLocal ? '/login?pick=1' : undefined)
  },
  // called when the API returns an error
  checkError: ({ status, graphQLErrors }) => {
    if (graphQLErrors[0].code === 401) {
      localStorage.removeItem('token')
      return Promise.reject({ redirectTo: '/login' })
    }
    return Promise.resolve()
  },
  // called when the user navigates to a new location, to check for authentication
  checkAuth: () => {
    return localStorage.getItem('token')
      ? Promise.resolve()
      : Promise.reject()
  },
  // called when the user navigates to a new location, to check for permissions / roles
  getPermissions: () => {
    const token = localStorage.getItem('token')
    const {role} = decodeJwt(token)
    if (role === 'ROLE_ASSISTANT_PREFERENCE') {
      return Promise.resolve(['ROLE_ASSISTANT'])
    }
    return Promise.resolve([role])
  },
}

export const hasPermission = (
  permissions = [],
  Model,
  roles = [],
) => {
  if (permissions == null) return null
  // This used to push ROLE_ASSISTANT onto every gate, which handed assistants
  // every ROLE_ADMIN-only resource: the user role editor, the global check-in
  // config and place creation. Each gate now means exactly what it says.
  const allowed = typeof roles === 'string' ? [roles] : roles
  return permissions.some(role => allowed.includes(role))
    ? Model
    : null
}
